import { render, staticRenderFns } from "./SaleSampleEdit.vue?vue&type=template&id=98e63be8"
import script from "./SaleSampleEdit.vue?vue&type=script&lang=js"
export * from "./SaleSampleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports